import React from "react";

function formatTimestamp(timestamp) {
    if (!timestamp) {
        return "–";
    }
    const date = new Date(timestamp);
    if (Number.isNaN(date.getTime())) {
        return "–";
    }
    return date.toLocaleString("de-DE");
}

export default function LogTimeline({ correlationId, timeline, isLoading }) {
    if (!correlationId) {
        return (
            <div className="rounded-xl border border-dashed border-slate-200 p-6 text-center text-sm text-slate-500">
                Wählen Sie einen Logeintrag mit Correlation ID aus, um die Timeline zu sehen.
            </div>
        );
    }

    return (
        <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
            <div className="flex items-center justify-between">
                <div>
                    <h3 className="text-sm font-semibold text-slate-700">Timeline für {correlationId}</h3>
                    {timeline.firstSeen ? (
                        <p className="text-xs text-slate-500">
                            {formatTimestamp(timeline.firstSeen)} – {formatTimestamp(timeline.lastSeen)}
                        </p>
                    ) : null}
                </div>
                {isLoading ? <span className="text-xs text-slate-500">lädt ...</span> : null}
            </div>
            <ol className="mt-4 space-y-3">
                {timeline.entries?.length ? (
                    timeline.entries.map((entry) => (
                        <li key={entry.id} className="relative border-l border-slate-200 pl-4">
                            <span className="absolute -left-1.5 top-1 h-3 w-3 rounded-full border border-blue-200 bg-blue-500" />
                            <p className="text-xs text-slate-500">{formatTimestamp(entry.createdAt)}</p>
                            <p className="text-sm font-semibold text-slate-700">{entry.event}</p>
                            <p className="text-sm text-slate-600">{entry.message}</p>
                            <div className="mt-1 flex flex-wrap gap-2 text-xs text-slate-500">
                                {entry.method ? <span className="rounded bg-slate-100 px-2 py-0.5">{entry.method}</span> : null}
                                {entry.path ? <span className="rounded bg-slate-100 px-2 py-0.5">{entry.path}</span> : null}
                                {entry.status ? <span className="rounded bg-slate-100 px-2 py-0.5">Status {entry.status}</span> : null}
                                {entry.durationMs != null ? (
                                    <span className="rounded bg-slate-100 px-2 py-0.5">{entry.durationMs} ms</span>
                                ) : null}
                                {entry.outcome ? <span className="rounded bg-slate-100 px-2 py-0.5">{entry.outcome}</span> : null}
                            </div>
                        </li>
                    ))
                ) : (
                    <li className="text-sm text-slate-500">Keine Timeline-Einträge vorhanden.</li>
                )}
            </ol>
        </div>
    );
}
